import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { m } from 'framer-motion';

const AnimatedSection = forwardRef(({ delay = 0, children, ...other }, ref) => (
    <Box
        ref={ref}
        component={m.div}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay, ease: [0.25, 0.1, 0.25, 1] }}
        {...other}
    >
        {children}
    </Box>
));

AnimatedSection.displayName = 'AnimatedSection';

AnimatedSection.propTypes = {
    delay: PropTypes.number,
    children: PropTypes.node,
};

AnimatedSection.defaultProps = {
    delay: 0,
};

export default AnimatedSection;
